const t = {
  name: "UnitedStatesDollar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,11V9h-2v2c-2.2,0-4,1.8-4,4v1.2c0,1.5,0.9,2.9,2.2,3.6l1.8,0.9V27c-1.1,0-2-0.9-2-2h-2c0,2.2,1.8,4,4,4v2
			h2v-2c2.2,0,4-1.8,4-4v-1.1c0-1.5-0.9-2.9-2.2-3.6L21,19.4V13c1.1,0,2,0.9,2,2h2C25,12.8,23.2,11,21,11z M19,13v5.4l-0.9-0.4
			c-0.7-0.3-1.1-1-1.1-1.8V15C17,13.9,17.9,13,19,13z M21,21.6l0.9,0.4l0,0c0.7,0.3,1.1,1,1.1,1.8V25c0,1.1-0.9,2-2,2V21.6z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as UnitedStatesDollar
};
